import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=4120cb0e&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=4120cb0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120cb0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4120cb0e')) {
      api.createRecord('4120cb0e', component.options)
    } else {
      api.reload('4120cb0e', component.options)
    }
    module.hot.accept("./HelpCenter.vue?vue&type=template&id=4120cb0e&scoped=true", function () {
      api.rerender('4120cb0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/help-center/HelpCenter.vue"
export default component.exports